'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

var _iconPopupSelector = require('./popup/iconPopupSelector');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _ElementIcon = require('../../../../components/elementIcon/ElementIcon');

var _ElementIcon2 = _interopRequireDefault(_ElementIcon);

var _IconPopup = require('./popup/IconPopup');

var _IconPopup2 = _interopRequireDefault(_IconPopup);

var _IconToolImage = require('./popup/IconToolImage');

var _IconToolImage2 = _interopRequireDefault(_IconToolImage);

var _popupActions = require('../../../../components/popupPanel/popupActions');

require('./IconTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions


// Components


// Selectors
var iconToolSelector = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)('icon'), _iconPopupSelector.popupModeSelector, _iconPopupSelector.selectedIconSelector, _iconPopupSelector.selectedImageSelector, _iconPopupSelector.firstElementIdSelector, function (popupIsOpen, popupMode, selectedIcon, selectedImage, firstElementId) {
    return {
        popupIsOpen: popupIsOpen,
        selectedIcon: selectedIcon,
        selectedImage: selectedImage,
        popupMode: popupMode,
        firstElementId: firstElementId
    };
});

// Styles


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        openIconPopup: function openIconPopup() {
            return dispatch((0, _popupActions.togglePopup)('icon'));
        }
    };
};

var IconTool = function IconTool(props) {
    var openIconPopup = props.openIconPopup,
        selectedIcon = props.selectedIcon,
        selectedImage = props.selectedImage,
        popupIsOpen = props.popupIsOpen;


    var iconElement = selectedImage ? _react2.default.createElement(_IconToolImage2.default, { imageSource: selectedImage }) : _react2.default.createElement(_ElementIcon2.default, { icon: selectedIcon });

    return _react2.default.createElement(
        'div',
        { className: 'icon-tool-container' },
        _react2.default.createElement(
            _Tool2.default,
            { className: 'IconTool',
                name: 'Icon',
                handleClick: openIconPopup,
                isActive: popupIsOpen },
            iconElement
        ),
        _react2.default.createElement(_IconPopup2.default, props)
    );
};

IconTool.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    openIconPopup: _propTypes2.default.func,
    selectedIcon: _propTypes2.default.object,
    popupIsOpen: _propTypes2.default.bool,
    selectedElements: _propTypes2.default.object,
    selectedImage: _propTypes2.default.string,
    firstElementId: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(iconToolSelector, mapDispatchToProps)(IconTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/IconTool.js
// module id = 2233
// module chunks = 0